"use client";

import { RefObject } from "react";
import create from "zustand";
import { devtools } from "zustand/middleware";

export type IFocusState = {
  overridePageTopFocus: boolean;
  setOverridePageTopFocus: (v: boolean) => void;
  onPageLoadRef: RefObject<any>;
  setOnPageLoadRef: (v: RefObject<any>) => void;
};
export const useFocusState = create<IFocusState>(
  devtools(
    (set) => ({
      overridePageTopFocus: false,
      setOverridePageTopFocus: (overridePageTopFocus: boolean) =>
        set((_state: IFocusState) => ({ overridePageTopFocus })),
      onPageLoadRef: null,
      setOnPageLoadRef: (onPageLoadRef: RefObject<any>) =>
        set((_state: IFocusState) => ({ onPageLoadRef })),
    }),
    { name: "FOCUS_STATE" },
  ),
);
